__turbopack_context__.v({
  "content": "Layout-module__1wQLna__content",
  "contentShell": "Layout-module__1wQLna__contentShell",
  "footer": "Layout-module__1wQLna__footer",
  "root": "Layout-module__1wQLna__root",
  "splineContainer": "Layout-module__1wQLna__splineContainer",
});
